<template>
  <stepForm
    :user="user"
    :request="request"
    :request-buttons="requestButtons"
    :btn-position="btnPosition"
    @input="$emit('input')"
  ></stepForm>
</template>

<script>
import stepForm from '@/components/shared/stepForm';

export default {
  name: 'StepOneRecovery',
  props: ['user'],
  components: {
    stepForm,
  },
  computed: {
    request() {
      const requestData = {
        requestFor: this.$t('days.off.request.for'),
        title: this.$t('recovery.request.step.one.title'),
        description: this.$t('recovery.request.step.one.description'),
        videoUrl: this.$t('recovery.request.video.url'),
        leftLeaves: this.$t('days.off.request.step.one.left.cp', {
          totalCp: this.user.freeHoursAvailable,
        }),
      };
      return requestData;
    },

    requestButtons() {
      const requestBtns = {
        next: this.$t('global.next'),
      };
      return requestBtns;
    },

    btnPosition() {
      const buttonStyle = {
        btnHistoryClass: 'btn-wrapper d-flex justify-content-between',
        btnClass: 'ml-md-auto mr-md-0 mx-auto',
      };
      return buttonStyle;
    },
  },
};
</script>

<style scoped>
</style>
